import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { RoleContext } from "./Auth/RoleProvider";
import { whoAmIUrl } from "./URL/ApplicationUrls";

async function whoAmI() {
  const response = await axios.get(whoAmIUrl.apiUrl);
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }
  return response.data;
}

export default function WhoAmIPage() {
  const [user, setUser] = useState("no user");
  const { roles } = useContext(RoleContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    async function fetchUser() {
      const response = await whoAmI();
      setUser(response);
    }

    fetchUser().catch(console.error);
  }, []);

  return (
    <>
      <p>
        Token Roles: <pre>{roles.join(", ")}</pre>
      </p>
      <p>
        You are user:{" "}
        <pre>{JSON.stringify(user, null, 4) || "not authenticated"}</pre>
      </p>
    </>
  );
}
